export default __webpack_public_path__ + "static/media/breadcrumb-divider.eedba1fd.svg";